/**
 * Shared no-op callback.
 *
 * Lives in this dependency-free leaf module (NOT in `extViewmodels/Utils`) so UI primitives like
 * `web/components/Button` can import it without dragging in the MobX SDK: `Utils.ts` does
 * `import * as ViewModels from '.'` + `import * as Api from './sdk'`, so importing anything from it
 * pulls the whole SDK graph — which breaks consumers that don't / can't take that dependency
 * (e.g. `packages/plugin-v2`, whose tsconfig has no `@ViewModels` alias). `Utils` re-exports this
 * for back-compat, so existing `import { Noop } from '.../extViewmodels/Utils'` keeps working.
 */
export const Noop = () => {
	// do nothing
};
